// User Management module internationalization - English
export default {
  title: 'User Management',
  description: 'Manage system user accounts, including user information, permissions and status',

  // Fields
  fields: {
    username: 'Username',
    email: 'Email Address',
    phone: 'Phone Number',
    company: 'Company',
    role: 'User Role',
    status: 'User Status',
    lastLogin: 'Last Login',
    createTime: 'Create Time',
    userId: 'User ID',
    newPassword: 'New Password',
    currentStatus: 'Current Status'
  },

  // Statistics
  stats: {
    totalUsers: 'Total Users',
    activeUsers: 'Active Users',
    inactiveUsers: 'Inactive Users',
    pendingUsers: 'Pending Users'
  },

  // Status
  status: {
    title: 'Status',
    all: 'All Status',
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    unknown: 'Unknown'
  },

  // Roles
  roles: {
    all: 'All Roles',
    superAdmin: 'Super Admin',
    user: 'User',
    unknown: 'Unknown'
  },

  // Actions
  actions: {
    addUser: 'Add User',
    editUser: 'Edit User',
    userDetail: 'User Detail',
    detail: 'Detail',
    enable: 'Enable',
    disable: 'Disable',
    resetPassword: 'Reset Password',
    bindCompany: 'Bind Company',
    toggleStatus: 'Toggle Status Confirmation'
  },

  // Forms
  forms: {
    searchPlaceholder: 'Search username, email or company',
    statusFilter: 'Status Filter',
    roleFilter: 'Role Filter',
    usernamePlaceholder: 'Please enter username',
    usernameRequired: 'Please enter username',
    emailPlaceholder: 'Please enter email address',
    emailRequired: 'Please enter email address',
    emailInvalid: 'Please enter valid email address',
    phonePlaceholder: 'Please enter phone number',
    phoneRequired: 'Please enter phone number',
    companyPlaceholder: 'Please enter company',
    companyRequired: 'Please enter company',
    rolePlaceholder: 'Please select user role',
    roleRequired: 'Please select user role',
    statusPlaceholder: 'Please select user status',
    statusRequired: 'Please select user status'
  },

  // Messages
  messages: {
    showAllUsers: 'Show all users',
    filterActiveUsers: 'Filter active users',
    filterInactiveUsers: 'Filter inactive users',
    filterPendingUsers: 'Filter pending users',
    searchSuccess: 'Search completed',
    refreshSuccess: 'Data refreshed',
    addSuccess: 'User added successfully',
    updateSuccess: 'User information updated',
    deleteSuccess: 'User {username} deleted',
    statusToggled: 'User {username} has been {status}',
    passwordResetSuccess: 'User {username} password reset successfully',
    resetPasswordWarning: 'Password Reset Warning',
    resetPasswordDesc: 'About to reset password for user {username}, new password will be randomly generated.',
    disableWarning: 'After disabling, the user will not be able to log into the system, and all ongoing operations will be interrupted.',
    enableInfo: 'After enabling, the user will restore normal system access permissions and can log in to use the system again.',
    autoFilterCompany: 'Automatically filtered company: {company}'
  }
}